
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as DataIconComponent } from "./data-icon.svg";

export const DataIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <DataIconComponent {...props} />;
};
